import _WidgetBaseSP from 'more/_WidgetBaseSP';

import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './OccurrenceOfflineManager.html?raw'; // (mds) pristine pointed at nonexistent PepHome.html — orphan never bundled by webpack
import topic from 'dojo/topic';

namespace OccurrenceFM {
    type OfflineManager__mdsbase = InstanceType<typeof _WidgetBaseSP>;
export interface OfflineManager extends OfflineManager__mdsbase { }
    export class OfflineManager extends compose(_WidgetBaseSP) {

        templateString;
        data: any;
        online: boolean;

        connectionStatus: HTMLElement;
        connectionStatusLabel: HTMLElement;

        analyzeData(): void {

            if (this.data == null) {
                topic.publish("/OfflineManager/Message", false, this.translations["OccurrenceOfflineManager_NoData"]);
                return;
            }

            topic.publish("/OfflineManager/Message", false, "ready");
        }


        _onOfflineOnlineChanged(): void {
            this.UiModder.domClass.remove(this.connectionStatus, "w3-text-green w3-text-red w3-pale-red");
            this.UiModder.domAttr.set(this.connectionStatusLabel, "innerHTML", "");

            if (navigator.onLine == true) {
                this.online = true;

                this.UiModder.domClass.add(this.connectionStatus, "w3-text-green mds-bg-gray");
                this.UiModder.domAttr.set(this.connectionStatusLabel, "innerHTML", this.translations["General_Online"]);

            } else {
                this.online = false;

                this.UiModder.domClass.add(this.connectionStatus, "w3-text-red w3-pale-red");
                this.UiModder.domAttr.set(this.connectionStatusLabel, "innerHTML", this.translations["General_Offline"]);
            }

            topic.publish("/OccurrenceFM/OfflineManager/OfflineStateChange");
        }



        _setupSubscriptions(): void {

            window.addEventListener('online', lang.hitch(this, "_onOfflineOnlineChanged"));
            window.addEventListener('offline', lang.hitch(this, "_onOfflineOnlineChanged"));

        }

        postMixInProperties(): void {
            let self: any = this;
            super.postMixInProperties.apply(this, arguments as any);
        }
        postCreate(): void {
            let self: any = this;
            super.postCreate.apply(this, arguments as any);
        }

        startup(): void {
            let self: any = this;
            super.startup.apply(this, arguments as any);

            this.analyzeData();
            this._onOfflineOnlineChanged();

        }
    }
    
}
Object.assign(OccurrenceFM.OfflineManager.prototype, {
  templateString: template,
  data: null,
  online: false,
  declaredClass: 'OfflineManager',
});
export default mdsWidget(OccurrenceFM.OfflineManager, 'WidgetCollection/OccurrenceFM/OccurrenceOfflineManager');